import { capitalizeFirstLetter } from "helpers/string";

import { useArrangementState } from "./ArrangementContext";

/** Fallback used wherever the loved one's first name is unavailable. */
export const LOVED_ONE_FALLBACK = "your loved one";

/**
 * The loved one's first name (capitalized) for warm, personalized copy, or
 * "your loved one" when the case has no decedent first name yet. The fallback
 * reads grammatically in every string it's dropped into, including the
 * possessive form (`${name}'s arrangements`).
 */
export function useLovedOneFirstName(): string {
  const { config } = useArrangementState();
  const firstName = config?.case_context?.dcd_first_name?.trim();
  return firstName ? capitalizeFirstLetter(firstName) : LOVED_ONE_FALLBACK;
}
